/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
  numeroFicha: string;
  cpfCnpj: string;
  idLeadCorretor: string;
  idCorretorLead: string;
  idCorretorFifty: string;
  imobiliaria?: boolean;
  cnpj?: string;
  cpf?: string;
  numeroCreci?: string;
  nomeImobiliaria?: string;
  autonomo?: boolean;
  nomeAutonomo?: string;
  email?: string;
  nomeCorretorFifty: string;
  clienteNaMesa: boolean;
  contratoFisico: boolean;
  tipoPagamento: string;
}

export function useEntradaProcesso(props: Props) {
  const postData = async () => {
    const ENTRADA_PROCESSO = `${backofficeEnviroment}/common/backoffice/entrada-processo/v1?`;
    const params = {
      idOportunidade: props.idOportunidade,
      numeroFicha: Number(props.numeroFicha),
      cpfCnpj: props.cpfCnpj,
      idLeadCorretor: props.idLeadCorretor,
      idCorretorLead: props.idCorretorLead,
      idCorretorFifty: props.idCorretorFifty,
      cnpj: props.cnpj,
      cpf: props.cpf,
      numeroCreci: props.numeroCreci,
      nomeImobiliaria: props.nomeImobiliaria,
      nomeAutonomo: props.nomeAutonomo,
      email: props.email,
      nomeCorretorFifty: props.nomeCorretorFifty,
      clienteNaMesa: props.clienteNaMesa,
      contratoFisico: props.contratoFisico,
      tipoPagamento: Number(props.tipoPagamento),
    };

    const params_: any = { ...params };

    // Só adiciona imobiliaria ou autonomo se for explicitamente true
    if (props.autonomo === true) {
      params_.autonomo = true;
    } else if (props.imobiliaria === true) {
      params_.imobiliaria = true;

        }

    const { data } = await instance.put(ENTRADA_PROCESSO, params_);
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Entrada de processo feita com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao iniciar a entrada de processo. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
